module.exports = __webpack_public_path__ + "static/img/pozajmice.a839b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/pozajmice.png
// module id = +8xv
// module chunks = 0